"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageFive = void 0;
exports.pageFive = () => ({
    content: [
        {
            margin: [0, 0, 0, 20],
            layout: 'noBorders',
            table: {
                widths: [120, 120],
                headerRows: 1,
                body: [
                    [
                        {
                            stack: [
                                'Abbie A',
                                'a, a SC 92068',
                                'DOB: 08/22/2018',
                                'Gender: Female',
                            ],
                            fontSize: 8,
                        },
                        { image: 'barcodeImage.png', width: 75 },
                    ],
                ],
            },
        },
        { text: 'Medication Instructions / Warnings / Counseling', fontSize: 16, alignment: 'center' },
        {
            style: 'tableText',
            stack: [
                `Important: Please review these important instructions and medication warnings about the medication being dispensed to you. These are summaries and do NOT have all possible information about these products. This information is not individual medical advice and does not substitute for the advice of your health care professional. Always ask your health care professional for complete information about these products and your specific health needs.`,
                {
                    text: 'Call your doctor for medical advice about side effects. You may report side effects to the FDA at 1-800-FDA-1088.',
                    bold: true,
                    margin: [0, 10, 0, 15],
                },
                {
                    text: 'These instructions are specifically for patient Name. If this is not you, please disregard these instructions and contact your health care professional.',
                    // bold: true, 
                    margin: [0, 0, 0, 15],
                },
            ],
        },
        {
            style: 'tableText',
            // text: 'Rx # 295 76420-0720-01: Bupivilog Kit',
            stack: [
                {
                    text: 'Rx # 295 76420-0720-01: Bupivilog Kit',
                    bold: true,
                },
                { ul: [
                        'Instructions: in office use only',
                        'Instructions: once in office use For external use only.',
                        'Avoid contact with eyes Wash hands after use',
                    ],
                },
                {
                    text: 'Do you requiire any additional counseling (Circle one)    YES / NO',
                    bold: true,
                    margin: [0, 10, 0, 0],
                },
            ],
            // text: {
            //     text: 'Do you requiire any additional counseling (Circle one)    YES / NO',
            //     bold: true,
            //     margin: [0, 10, 0, 0],
            // },
            margin: [0, 0, 0, 50],
        },
        { text: 'Patient Signature: _________________________  Date: _______________', alignment: 'left' },
    ],
    styles: {
        tableText: {
            fontSize: 8,
            bold: false,
            margin: [-20, 15, 0, 0],
            alignment: 'left',
        },
        notice: {
            fontSize: 8,
            margin: [50, 30, 0, 0],
            alignment: 'center',
        },
        barcode: {
            alignment: 'center',
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/pdfs/fifthPage.ts
// module id = 2727
// module chunks = 0 1